import { render, staticRenderFns } from "./addDevice.vue?vue&type=template&id=2bd05964&"
import script from "./addDevice.vue?vue&type=script&lang=ts&"
export * from "./addDevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports